import lang from 'lang'
import request from '@/modules/base/util/request'
import documentExportConfig from '@/modules/document-export/config'
import settingsConfig from '@/modules/settings/config'

import { toast } from '@/modules/base/components/toast/toastConfig'

// actions
const SHOW_LOADER = 'documentExport/list/SHOW_LOADER'
const HIDE_LOADER = 'documentExport/list/HIDE_LOADER'
const SHOW_MODAL_LOADER = 'documentExport/list/SHOW_MODAL_LOADER'
const HIDE_MODAL_LOADER = 'documentExport/list/HIDE_MODAL_LOADER'
const OPEN_MODAL = 'documentExport/list/OPEN_MODAL'
const CLOSE_MODAL = 'documentExport/list/CLOSE_MODAL'
const OPEN_FIX_ERRORS_DRAWER = 'documentExport/list/OPEN_FIX_ERRORS_DRAWER'
const CLOSE_FIX_ERRORS_DRAWER = 'documentExport/list/CLOSE_FIX_ERRORS_DRAWER'
const REFRESH = 'documentExport/list/REFRESH'
const STOP_REFRESHING = 'documentExport/list/STOP_REFRESHING'
const SET_DOCUMENT_EXPORTS = 'documentExport/list/SET_DOCUMENT_EXPORTS'
const SET_TAX_ACCOUNTANT = 'documentExport/list/SET_TAX_ACCOUNTANT'

// reducer
const initialState = {
  isLoading: true,
  isModalLoading: false,
  documentExports: [],
  shouldRefresh: false,
  taxAccountant: {
    consultantId: '',
    clientId: '',
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_LOADER:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SHOW_MODAL_LOADER:
      return { ...state, isModalLoading: true }

    case HIDE_MODAL_LOADER:
      return { ...state, isModalLoading: false }

    case REFRESH:
      return { ...state, shouldRefresh: true }

    case STOP_REFRESHING:
      return { ...state, shoudlRefresh: false }

    case OPEN_MODAL:
      const { selectedExport } = action
      return { ...state, selectedExport, modalOpen: true }

    case CLOSE_MODAL:
      return { ...state, selectedExport: undefined, modalOpen: false }

    case OPEN_FIX_ERRORS_DRAWER:
      const { fixErrorsDocuments } = action
      return { ...state, fixErrorsDocuments, fixErrorsOpen: true }

    case CLOSE_FIX_ERRORS_DRAWER:
      return { ...state, fixErrorsDocuments: undefined, fixErrorsOpen: false }

    case SET_DOCUMENT_EXPORTS:
      const { documentExports } = action
      return { ...state, documentExports }

    case SET_TAX_ACCOUNTANT:
      const { taxAccountant } = action
      return { ...state, taxAccountant }

    default:
      return state
  }
}

// action creators
export const showLoader = () => ({
  type: SHOW_LOADER,
})

export const hideLoader = () => ({
  type: HIDE_LOADER,
})

export const refreshList = () => ({
  type: REFRESH,
})

export const stopRefreshing = () => ({
  type: STOP_REFRESHING,
})

export const openEmailModal = (selectedExport) => ({
  type: OPEN_MODAL,
  selectedExport,
})

export const closeEmailModal = () => ({
  type: CLOSE_MODAL,
})

export const openFixErrorsDrawer = (fixErrorsDocuments) => ({
  type: OPEN_FIX_ERRORS_DRAWER,
  fixErrorsDocuments,
})

export const closeFixErrorsDrawer = () => ({
  type: CLOSE_FIX_ERRORS_DRAWER,
})

export const showModalLoader = () => ({
  type: SHOW_MODAL_LOADER,
})

export const hideModalLoader = () => ({
  type: HIDE_MODAL_LOADER,
})

const setDocumentExports = (documentExports) => ({
  type: SET_DOCUMENT_EXPORTS,
  documentExports,
})

const setTaxAccountant = (taxAccountant) => ({
  type: SET_TAX_ACCOUNTANT,
  taxAccountant,
})

export const sendDocumentExport = (id, data) => {
  return (dispatch) => {
    dispatch(showModalLoader())
    request(`${documentExportConfig.accountantExportUrl}${id}/send`, {
      auth: true,
      data,
      method: 'POST',
    })
      .then(() => {
        toast.showToast({ message: lang.documentExport.sendSuccess })
        dispatch(closeEmailModal())
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.documentExport.sendError }))
      .done(() => dispatch(hideModalLoader()))
  }
}

export const fetchDocumentExports = (collaborationId) => {
  const headers = {}
  if (collaborationId) headers['collaboration-id'] = collaborationId

  return (dispatch) => {
    dispatch(showLoader())
    request(`${documentExportConfig.accountantExportUrl}`, { auth: true, isConcurrent: true, headers })
      .then((response) => {
        const {
          body: {
            data: documentExports,
          },
        } = response

        documentExports.map(documentExport => {
          const { status } = documentExport
          if (status === 'pending') {
            dispatch(setIntervalForStatusCheck(documentExport, 1, collaborationId))
          }
        })

        dispatch(setDocumentExports(documentExports))
      })
      .catch((e) => {
        console.error(e, 'fetchDocumentExports error')
        toast.showToast({ type: 'error', message: lang.documentExport.fetchingErrorMessage })
      })
      .done(() => dispatch(hideLoader()))
  }
}

export const fetchTaxAccountantSettings = (collaborationId) => {
  const headers = {}
  if (collaborationId) headers['collaboration-id'] = collaborationId

  return (dispatch) => {
    dispatch(showLoader())
    request(settingsConfig.taxAccountantSettings, { auth: true, isConcurrent: true, headers })
      .then((response) => {
        const { body: { data } } = response
        dispatch(setTaxAccountant(data))
      })
      .catch(() => {
        toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
      })
      .done(() => dispatch(hideLoader()))
  }
}

const pendingUpdates = []

const checkStatus = (documentExport, collaborationId) => {
  const headers = {}
  if (collaborationId) headers['collaboration-id'] = collaborationId

  const { id } = documentExport
  return request(`${documentExportConfig.accountantExportUrl}${id}`, { auth: true, headers })
    .then((response) => {
      const { data: { status, documentUrl } } = response.body
      return { ...documentExport, status, documentUrl: documentUrl || null }
    })
}

const setIntervalForStatusCheck = (documentExport, timer, collaborationId) => {
  return (dispatch, getState) => {
    const { id, status } = documentExport

    if (pendingUpdates[id]) {
      window.clearTimeout(pendingUpdates[id])
    }
    if (status !== 'pending') return

    pendingUpdates[id] = window.setTimeout(() => {
      checkStatus(documentExport, collaborationId)
        .then((result) => {
          if (result.status === 'pending') {
            return dispatch(setIntervalForStatusCheck(result, timer * 2, collaborationId))
          }

          const { documentExport: { list: { documentExports } } } = getState()
          const updatedExports = documentExports.map(docExport => {
            return docExport.id === id ? { ...docExport, ...result } : docExport
          })

          dispatch(setDocumentExports(updatedExports))

          window.clearTimeout(pendingUpdates[result.id])
        })
    }, timer * 1000)
  }
}

export const clearPendingUpdates = () => {
  for (const key in pendingUpdates) {
    if (pendingUpdates.hasOwnProperty(key)) {
      window.clearTimeout(pendingUpdates[key])
    }
  }
}
